import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
    return (
        <Typewriter
            options={{
                strings: [
                    "Bespoke Software, Unleashed.",
                    "Full-Stack Excellence for Your Business",
                    "From Concept to Custom Code",
                    "Innovation, Code, and Infinite Possibilities."
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 50,
            }}
        />
    );
}

export default Type;
